import { Phone, MessageSquare, ArrowRight } from "lucide-react";
import { SITE, waLink } from "../../lib/site";

export const CTA = () => {
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[var(--bg-surface)] border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.18),transparent_55%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(255,45,156,0.22),transparent_55%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_left,rgba(168,85,247,0.16),transparent_55%)]" />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <span className="eyebrow">Parlons-en</span>
        <h2 className="mt-3 text-3xl sm:text-4xl lg:text-6xl font-bold tracking-tight">
          Votre date est unique.
          <br />
          <span className="gold-text-gradient">Réservez-la maintenant.</span>
        </h2>
        <p className="mt-6 text-zinc-300 max-w-2xl mx-auto leading-relaxed">
          Je ne prends qu'un seul événement par soirée pour garantir l'excellence.
          Plus tôt vous me parlez de votre projet, plus je peux le préparer en
          profondeur. Réponse claire et personnalisée sous 24 h.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="#contact"
            data-testid="cta-quote-btn"
            className="btn-gold rounded-full px-7 py-4 text-sm md:text-base inline-flex items-center justify-center gap-2"
          >
            Demander un devis <ArrowRight size={18} />
          </a>
          <a
            href={`tel:${SITE.phoneInternational}`}
            data-testid="cta-call-btn"
            className="btn-outline-gold rounded-full px-7 py-4 text-sm md:text-base inline-flex items-center justify-center gap-2"
          >
            <Phone size={16} /> Appeler maintenant
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-btn"
            className="btn-whatsapp rounded-full px-7 py-4 text-sm md:text-base inline-flex items-center justify-center gap-2"
          >
            <MessageSquare size={16} /> Écrire sur WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};
